export default function formatString(template?: string, param?: any) {
  return template?.replace(/\${(\w+)}/g, function (_, key) {
    if (!param?.hasOwnProperty(key)) {
      console.error(`[formatString] ${key} is not exist`, param);
    }
    return param?.[key];
  });
}
